"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
exports.NUM_GROUPS = 3;
exports.MAX_NUM_GROUPS = 9;
exports.widgetLayoutSettings = {
    numberGroups: {
        getDefaultValue: function () { return exports.NUM_GROUPS; },
        key: 'numberGroups',
    },
    imageRatio: {
        getDefaultValue: function () { return types_1.ImageRatio.square; },
        key: 'imageRatio',
    },
    groupListLayout: {
        getDefaultValue: function () { return types_1.LayoutType.listWidget; },
        key: 'groupListLayout',
    },
    gridCardSpacing: {
        getDefaultValue: function () { return 12; },
        key: 'gridCardSpacing',
    },
};
exports.widgetDisplaySettings = {
    showActivity: {
        getDefaultValue: function () { return true; },
        key: 'showActivity',
    },
    showGroupType: {
        getDefaultValue: function () { return true; },
        key: 'showGroupType',
    },
    showButton: {
        getDefaultValue: function () { return true; },
        key: 'showButton',
    },
};
//# sourceMappingURL=widgetSettings.js.map